export default function TagUserIndigo() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 4H12C8.68 4 6 6.66 6 9.94V31.76C6 35.04 8.68 37.72 12 37.72H13.52C15.1 37.72 16.64 38.34 17.76 39.46L21.18 42.84C22.74 44.38 25.26 44.38 26.82 42.84L30.24 39.46C31.36 38.34 32.9 37.72 34.48 37.72H36C39.32 37.72 42 35.04 42 31.76V9.94C42 6.66 39.32 4 36 4ZM24 11.1C26.16 11.1 27.9 12.86 27.9 15C27.9 17.12 26.22 18.82 24.14 18.9C24.06 18.9 23.94 18.9 23.84 18.9C21.74 18.82 20.08 17.12 20.08 15C20.1 12.86 21.84 11.1 24 11.1ZM29.5 29.38C26.48 31.4 21.52 31.4 18.5 29.38C15.84 27.62 15.84 24.7 18.5 22.92C21.54 20.9 26.5 20.9 29.5 22.92C32.16 24.7 32.16 27.6 29.5 29.38Z"
        fill="#6155F5"
      />
    </svg>
  );
}
